import { ScreenTypeEnum, type ScreenBaseDTOV3 } from '@/common/types/screen'

export const getTreatmentScreen = (screens: ScreenBaseDTOV3[], spaceCode: UUID) => {
  return screens.find((screen) => {
    return screen.type === ScreenTypeEnum.TICKET && screen.spaceCode === spaceCode && !screen.creation
  })
}

export const getCustomerRecordScreen = (screens: ScreenBaseDTOV3[]) => {
  return screens.filter((screen) => screen.type === ScreenTypeEnum.CLIENT)[0]
}

export const getCompanyRecordScreen = (screens: ScreenBaseDTOV3[]) => {
  return screens.filter((screen) => screen.type === ScreenTypeEnum.COMPANY)[0]
}
